export default __webpack_public_path__ + "static/media/cardio-shadow.b1246c34.svg";